import { useState } from "react";

import { TPickerOption, TPickerProps } from "../../../Types";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import {
  RADIO_BACKGROUND_HOVER,
  RADIO_BACKGROUND_SELECTED,
  RADIO_BORDER,
  RADIO_BORDER_SELECTED,
  RADIO_DOT_SIZE,
  RADIO_GAP,
  RADIO_GROUP_GAP,
  RADIO_GROUP_HEIGHT,
  RADIO_GROUP_WIDTH,
  RADIO_HEIGHT,
  RADIO_LABEL_FONT_SIZE,
  RADIO_MIN_WIDTH,
  RADIO_PADDING_X,
  RADIO_RADIUS,
  RADIO_RING_BORDER_WIDTH,
  RADIO_RING_COLOR,
  RADIO_RING_SIZE,
  RADIO_SHADOW,
  RADIO_TRANSITION
} from "./radio-constants";

const RadioOption = withLiteObserverAndTheme<{
  option: TPickerOption;
  isSelected: boolean;
  onChoose: (value: unknown) => void;
}>((props) => {
  const { option, isSelected, onChoose, theme } = props;
  const { colors, unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);

  const backgroundColor = (() => {
    switch (true) {
      case isSelected:
        return RADIO_BACKGROUND_SELECTED;
      case isHovered:
        return RADIO_BACKGROUND_HOVER;
      default:
        return colors.all.white;
    }
  })();

  return (
    <button
      role="radio"
      aria-checked={isSelected}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onChoose(option.value)}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexShrink: 0,
        minWidth: RADIO_MIN_WIDTH * unitX,
        height: RADIO_HEIGHT * unitY,
        backgroundColor,
        borderRadius: RADIO_RADIUS * unitX,
        border: isSelected ? RADIO_BORDER_SELECTED : RADIO_BORDER,
        boxShadow: RADIO_SHADOW,
        transition: RADIO_TRANSITION,
        paddingLeft: RADIO_PADDING_X * unitX,
        paddingRight: RADIO_PADDING_X * unitX,
        gap: RADIO_GAP * unitX,
        cursor: "pointer"
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          width: RADIO_RING_SIZE * unitX,
          height: RADIO_RING_SIZE * unitX,
          borderRadius: RADIO_RING_SIZE * unitX,
          border: `${RADIO_RING_BORDER_WIDTH * unitX}px solid ${
            isSelected ? colors.all.bondiBlue : RADIO_RING_COLOR
          }`,
          transition: RADIO_TRANSITION
        }}
      >
        <div
          style={{
            width: RADIO_DOT_SIZE * unitX,
            height: RADIO_DOT_SIZE * unitX,
            borderRadius: RADIO_DOT_SIZE * unitX,
            backgroundColor: isSelected
              ? colors.all.bondiBlue
              : colors.all.transparent,
            transition: RADIO_TRANSITION
          }}
        />
      </div>
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={RADIO_LABEL_FONT_SIZE}
        text={`${option.label}`}
        isSpan={false}
        color={isSelected ? colors.all.bondiBlue : colors.all.maastrichtBlue}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />
    </button>
  );
});

const ET3Radio = withLiteObserverAndTheme<TPickerProps>((props) => {
  const { options, value, theme, style, onChoose } = props;
  const { colors, unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={RADIO_GROUP_WIDTH}
      height={RADIO_GROUP_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "auto",
        minWidth: 0,
        height: "auto",
        flexWrap: "wrap",
        gap: RADIO_GROUP_GAP * unitX,
        ...style
      }}
      onClick={() => {}}
    >
      {options.map((option: TPickerOption) => (
        <RadioOption
          key={`${option.value}`}
          option={option}
          isSelected={value === option.value}
          onChoose={onChoose}
        />
      ))}
    </ET3Div>
  );
});
export default ET3Radio;
